import dayjs from 'dayjs';
export default {
  formatTime: function formatTime(input) {
    return dayjs(input).format('YYYY-MM-DD HH:mm:ss');
  },
  formatDate: function formatDate(input) {
    return dayjs(input).format('YYYY年MM月DD日');
  },
  isUse: function isUse(input) {
    return input ? '可用' : '不可用';
  },
  orderStatus: function orderStatus(input) {
    switch (input) {
      case 'WAIT_PAY':
        return '未支付';

      case 'WAIT_CONFIRM':
        return '待确认';

      case 'WAIT_USE':
        return '待使用';

      case 'PART_USE':
        return '部分使用';

      case 'WAIT_CONFIRM_WAIT_AUDIT':
      case 'WAIT_USE_WAIT_AUDIT':
        return '退单审核';

      case 'AUDITED':
        return '审核通过';

      case 'CANCELED':
        return '已取消';

      case 'CLOSED':
        return '已关闭';

      case 'COMPLETE':
        return '已完成';
    }
  },
  payStatus: function payStatus(input) {
    switch (input) {
      // case 'WAIT_PAY':
      //   return '未支付'
      case 'PAYED':
        return '已支付';

      case 'REFUNDING':
        return '退款中';

      case 'REFUNDED':
        return '已退款';
      // case 'CLOSED':
      //   return '已关闭'
    }
  }
};